
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CustomsFee from "./customs-fee.vue";

@Component({ name: "FeeCalc", components: { CustomsFee } })
export default class FeeCalc extends Vue {
    created() { }
    mounted() { }
}
